import {
  deriveHashListByKeysFromDeployArgsObject,
  deriveHashListByKeysFromObject,
} from './account';
import {
  auctionMessage,
  csprMarkerMessage,
  ftTokenMessage,
  nftTokenMessage,
} from '../services/deploy-action-messages';

const getTransactionAccountAndPurseHashes = (deploysData) => {
  const publicKeysList =
    deriveHashListByKeysFromObject(deploysData, [
      'callerPublicKey',
      'callerHash',
    ]) || [];

  const accountAndPurseHashesListArgs =
    deriveHashListByKeysFromDeployArgsObject(deploysData, [
      ...auctionMessage().getRelevantAccountHashesFromArgs(),
      ...csprMarkerMessage().getRelevantAccountHashesFromArgs(),
      ...nftTokenMessage().getRelevantAccountHashesFromArgs(),
      ...ftTokenMessage().getRelevantAccountHashesFromArgs(),
      'target', // Transfer arguments
    ]) || [];

  return [...publicKeysList, ...accountAndPurseHashesListArgs];
};

export default getTransactionAccountAndPurseHashes;
